import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { App } from 'components/App/App';
import { AuthProvider } from 'services/auth/AuthProvider';
import { SnackbarProvider } from 'context/snackbar/SnackBarProvider';
import { reportWebVitals } from './reportWebVitals';
import './global.scss';
var root = ReactDOM.createRoot(document.getElementById('root'));
root.render(_jsx(React.StrictMode, { children: _jsx(AuthProvider, { children: _jsx(SnackbarProvider, { children: _jsx(App, {}) }) }) }));
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
